import { css } from '@emotion/react';
import { memo } from 'react';
import useMedia from '~/hooks/useMedia';
import { globalOrange } from '~/modules/AppLayout/Colors';
import { flex } from '~/modules/AppLayout/FlexGridCss';
import { fontWeight600 } from '~/css/font';
/**選擇權合成期貨 */
export const SyntheticFuturesQuote = memo(function SyntheticFuturesQuote(props) {
    const { isPc } = useMedia();
    return (<div css={css `
          ${optionRefQuoteBoxCss};
          padding: ${isPc ? '8px 16px' : '8px'};
          border: ${globalOrange.o700} 1px solid;
        `}>
        <p css={css `
            padding: 0px 4px };
          `}>
          選擇權合成期貨
        </p>
        <p>{props.syntheticIndexPrice.toFixed(0)}</p>
      </div>);
});
const optionRefQuoteBoxCss = css `
  ${flex.h.allCenter};
  min-width: 256px;
  border-radius: 8px;
  p {
    margin: 0;
    ${fontWeight600};
    font-size: 1rem;
    color: ${globalOrange.o700};
  }
`;
